import { render, staticRenderFns } from "./itemsettings.vue?vue&type=template&id=176aebe7&scoped=true&"
import script from "./itemsettings.vue?vue&type=script&lang=js&"
export * from "./itemsettings.vue?vue&type=script&lang=js&"
import style0 from "./itemsettings.vue?vue&type=style&index=0&id=176aebe7&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176aebe7",
  null
  
)

export default component.exports